import styled from "styled-components";
import { blinker } from "../../../../admin/src/components/SPGrid3/TopBar/blinker";

const isHex = (value) => value.startsWith("#");

export const DropDownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Wrapper = styled.div`
  @media ${(p) => p.theme.sm} {
    width: auto;
    margin: 0 25px 0 15px;
  }

  width: ${(p) => p.theme.height};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const IconWrapper = styled.div`
  margin-right: 15px;
  position: relative;
  cursor: pointer;

  &.clicked {
    animation: ${blinker} 0.6s;
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  border-bottom: ${(p) => (p.border ? "2px solid #f1f1f1" : "none")};
  transition: margin 300ms ease;
  user-select: none;

  &:hover {
    background-color: #f5f9ff;
    margin-left: 5px;
  }
`;

export const ItemIconWrapper = styled.div`
  width: 36px;
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  border-radius: 50%;
  background-color: ${(p) =>
    isHex(p.color) ? p.color + "4D" : p.theme.colors[p.color]};
  color: ${(p) => (isHex(p.color) ? p.color : p.theme.colors.on[p.color])};
`;

export const ItemIcon = styled.em``;

export const TextWrapper = styled.div`
  margin-left: 16px;
`;

export const ItemHeader = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
`;

export const ItemDesc = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
`;

export const DropDown = styled.ul`
  @media ${(p) => p.theme.breakpoints.sm} {
    top: 19px;
    right: ${(p) => (p.type === "create" ? "-6px" : "-2px")};
  }

  position: absolute;
  top: ${(p) => (p.type === "create" ? "5px" : "7px")};
  right: ${(p) => (p.type === "create" ? "-47px" : "6px")};
  width: ${(p) => (p.type === "create" ? "260px" : "220px")};
  padding: 8px 8px;
  background-color: ${(p) => p.theme.colors.surface};
  border: 2px solid #f1f1f1;
  border-radius: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
  z-index: 1;

  &::before {
    @media ${(p) => p.theme.breakpoints.sm} {
      right: 17px;
    }

    content: "";
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: -12px;
    right: ${(p) => (p.type === "create" ? "64px" : "10px")};
    border-bottom: 12px solid #fff;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    z-index: 1;
  }

  &::after {
    @media ${(p) => p.theme.breakpoints.sm} {
      right: 15px;
    }

    content: "";
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: -15px;
    right: ${(p) => (p.type === "create" ? "62px" : "8px")};
    border-bottom: 14px solid #f1f1f1;
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
  }
`;

export const More = styled.div`
  display: flex;
  &:after {
    content: " ▾";
    display: block;
    padding-left: 5px;
  }
  font-size: 0.9rem;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
`;

export const ConfirmOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const ConfirmModal = styled.div`
  padding: 10px 14px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
`;

export const ConfirmHeader = styled.h3``;

export const ConfirmText = styled.p``;

export const ConfirmButtons = styled.div`
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #ddd;
`;

export const Cancel = styled.span`
  color: ${(p) =>
    p.theme.colors.primary ? p.theme.colors.primary : "#404e67"};
  cursor: pointer;
`;

export const ConfirmRemoveButton = styled.button`
  padding: 5px 8px;
  background-color: ${(p) =>
    p.theme.colors.danger ? p.theme.colors.danger : "#404e67"};
  color: ${(p) =>
    p.theme.colors.on.danger ? p.theme.colors.on.danger : "#f5f5f5"};
  border: ${(p) =>
    p.theme.colors.border.danger
      ? `1px solid ${p.theme.colors.border.danger}`
      : "none"};
  border-radius: 4px;
`;
